import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKibanaComponent } from './simple-icons-kibana.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKibanaComponent ],
    exports:      [ SimpleIconsKibanaComponent ],
    bootstrap:    []
})
export class SimpleIconsKibanaModule {}
